window.EezyTurbolinksVisits = 0;
window.EezyTurbolinksPreviousUrl = '';

window.addEventListener('turbolinks:visit', () => {
  window.EezyTurbolinksVisits += 1;
});

window.addEventListener('turbolinks:request-start', () => {
  window.EezyTurbolinksPreviousUrl = window.location.pathname;
});
